import React, { useState } from "react";
import {
    Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import Settings from '@mui/icons-material/Settings'
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from '@mui/material/styles';
import {GlobalStyle as gs} from '@src/GlobalStyle'
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';

const useStyles = makeStyles(()=>({
    link:{
        textDecoration:"none",
        color: "#fff",
        fontSize: "20px",
    },
    icon:{
        color: "#fff"
    },
    right: {
      backgroundColor: gs.colors.bar
    }
}));

const LeftDrawer = ({sideMenu}) => {
  const classes = useStyles();
  const theme = useTheme()
  const [openDrawer, setOpenDrawer] = useState(false);
  const [activeIdx, set_activeIdx] = useState(0)
  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#fff'}}/>

  const sideMenu2= sideMenu.map(menu => {
    if (menu.icon) {
      // If 'icon' property exists, create a modified copy
      return {
        ...menu,
        icon: React.cloneElement(menu.icon, {
          sx: { color: '#fff' }
        })
      };
    }
    // If 'icon' property does not exist, return the original menu item
    return menu;
  });
  return (
    <>
      <Drawer
        open={openDrawer}
        anchor={'left'}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          className: classes.right,
          sx:{backgroundColor:gs.colors.bar}
        }}
      >
        <Toolbar />
        
        <List >          
          {
            sideMenu2 && sideMenu2.map((menu, index) => (
              menu.visible ? (
                menu.text === 'divider' ? (
                  <Divider/>
                ) : (
                  <ListItem key={menu.text} disablePadding component={Link} to={menu.to} 
                            onClick={()=> {
                              set_activeIdx(index)
                              setOpenDrawer(false)
                            }} 
                            style={{justifyContent:'center', alignItems:'center'}}
                  >
                    <ListItemButton selected={index === activeIdx} >
                      <ListItemIcon sx={{minWidth:'35px'}}>
                        {menu.icon ? menu.icon: defIcon}
                      </ListItemIcon>
                      <ListItemText 
                          primaryTypographyProps={{color:'#fff'}}
                          primary={menu.text} 
                      />
                    </ListItemButton>
                  </ListItem>
                )
              ) : null
            ))
          }
        </List>

        {/* <List > */}
        {/*   <ListItem onClick={() => setOpenDrawer(false)}> */}
        {/*     <ListItemText> */}
        {/*       <Link to="/profile" className={classes.link}>My</Link> */}
        {/*     </ListItemText> */}
        {/*   </ListItem> */}
        {/*   <Divider/> */}
        {/*   <ListItem onClick={() => setOpenDrawer(false)}> */}
        {/*     <ListItemText> */}
        {/*       <Link to="/logout" className={classes.link}>로그아웃</Link> */}
        {/*     </ListItemText> */}
        {/*   </ListItem> */}
        {/* </List> */}
        {/**/}
      </Drawer>
      <IconButton onClick={() => setOpenDrawer(!openDrawer)} className={classes.icon}>
        <MenuIcon sx={{color:'#fff'}} />
      </IconButton>
    </>
  );
}

export default LeftDrawer;
